import clsx from 'clsx';
import { useState, useEffect } from 'react';
import Footer from '../Components/Global/Footer';
import MainContent from '../Components/Global/MainContent';
import TechHeading from '../Components/TechHeading';
import { Video } from '../Components/Video';
import { Loader } from '../Components/Loader';
import QRCode from 'react-qr-code';
import Logo from '../img/logo.png';
import QR from '../img/qr-background.png';
import { LogoQR } from './Idle';

const headingClasses =
  'uppercase text-2xl !leading-[0.9] tracking-tight font-medium mt-2 whitespace-nowrap max-w-[10em] overflow-hidden text-ellipsis';
const qrTextClasses = 'w-[100%] right-[1%] uppercase 2xl:text-[210%] font-bold absolute z-[2] text-center';

const Lobby = ({ players, optionData, eventData, resetGame, lobbyId }) => {
  const [howManyPlayers, setHowManyPlayers] = useState(1);

  useEffect(() => {
    const p = players.length;
    console.log(p);
    setHowManyPlayers(p);
    return () => {};
  }, [players]);
  const showVideo = !eventData?.acf?.disable_video_background;
  return (
    <>
      {showVideo && <Video layer="bg" />}
      <MainContent>
        <GameHeader eventData={eventData} lobbyId={lobbyId} />
        <div className="section-player-list w-full flex flex-col items-center gap-3">
          <div className="w-full flex flex-col gap-[1vh] xl:gap-[2vh] px-[6vw] md:px-[4vw] lg:px-0">
            {/*
            !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            PLAYER 1
            !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
             */}
            <PlayerStatus
              player={players[0]}
              number="1"
              colourBg="bg-amethyst"
              colourText="text-amethyst"
              colourShadow1="drop-shadow-amethyst-sm"
              colourShadow2="drop-shadow-amethyst-lg"
            />
            {/*
            !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            PLAYER 2
            !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
             */}
            <PlayerStatus
              player={players[1]}
              number="2"
              colourBg="bg-flamingo"
              colourText="text-flamingo"
              colourShadow1="drop-shadow-flamingo-sm"
              colourShadow2="drop-shadow-flamingo-lg"
            />
            {/*
            !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            PLAYER 3
            !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
             */}
            <PlayerStatus
              player={players[2]}
              number="3"
              colourBg="bg-carnation"
              colourText="text-carnation"
              colourShadow1="drop-shadow-carnation-sm"
              colourShadow2="drop-shadow-carnation-lg"
            />
          </div>
        </div>
        <Footer showLogo eventData={eventData} optionData={optionData} resetGame={resetGame} />
      </MainContent>
      {showVideo && <Video layer="fg" />}
    </>
  );
};

const PlayerStatus = ({ player, number, colourBg, colourText, colourShadow1, colourShadow2 }) => {
  return (
    <article className="player-list-item relative w-full px-[1.5vw]">
      <div className="px-[3vw] -mb-[1vh]">
        <TechHeading text={'player ' + number} color={colourBg} clipPostion="top-right" classes={colourShadow1} />
        <p className={clsx(headingClasses, colourText)}>{player ? player.name : 'Waiting...'}</p>
      </div>
      <div className={clsx(colourText, 'relative w-full aspect-[1/0.35]')}>
        <svg className={clsx('absolute inset-0 w-full h-full z-[0] opacity-50')}>
          <use xlinkHref="#player-ui-bg" />
        </svg>
        <svg className={clsx('absolute inset-0 w-full h-full z-[1]', colourShadow2)}>
          <use xlinkHref="#player-ui" />
        </svg>
        <div className="aspect-[1/0.3] relative top-[7%] w-full z-[2] flex justify-between">
          <div className="w-full flex flex-col items-center">
            <TechHeading text="status" color={colourBg} clipPostion="bottom-right" classes={colourShadow1} />
            <div className={clsx(colourText, 'h-full flex items-center')}>
              <p
                className={clsx(
                  player && player.status === 'ready' ? '' : 'text-stroke',
                  'text-h1 font-bold !text-[18vw]',
                  colourShadow1
                )}
              >
                {player ? (player.status === 'not-ready' ? 'joined' : player.status) : 'Waiting'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
};

const GameHeader = ({ eventData, lobbyId }) => {
  if (eventData.acf) {
    return (
      <header className="container pb-[2vh]">
        <div className="absolute self-center top-[1vw] right-[1vw] flex justify-center pb-20">
          <div className="relative w-[8vh] mx-auto">
            <img className="mx-auto h-auto relative z-10" src={QR} alt="QR Code" />
            <div className="absolute z-20 w-full h-full top-0 left-0 flex justify-center flex-col items-center text-center text-dark">
              <p className="text-[1vh] leading-none font-bold py-[5%]">SCAN TO PLAY</p>
              <figure className="w-[70%]">
                <QRCode
                  className="relative w-full h-auto"
                  fgColor="#000"
                  value={`codecrackers-at-videri.kerve.com/${lobbyId}`}
                />
              </figure>

              <p className="text-[1vh] mx-0 leading-none font-bold py-[5%]">HACK AND WIN</p>
            </div>
          </div>
        </div>
        <div className="flex justify-center items-center flex-col">
          <TechHeading text="time remaining" color="bg-white" clipPostion="bottom-right" />
          <div className="mt-4">
            <p className="!font-mono font-light text-h3 text-current !text-[6vw]">02:00:00</p>
          </div>
        </div>

        {/* <div className="grow flex flex-col justify-center text-right section-sm">
          <div>
            {eventData && eventData.acf.name && <p className="text-h5 font-extrabold">{eventData.acf.name}</p>}
            {eventData && eventData.acf.details && (
              <p className="text-bold text-xl font-bold">{eventData.acf.details}</p>
            )}
          </div>
        </div> */}
      </header>
    );
  } else {
    <Loader />;
  }
};

export default Lobby;
